import styled from "styled-components";

export const TopTabStyled = styled.div`
  .top_tap_header_layout {
    margin-bottom: 1.875rem;
    border-radius: 1rem;
    padding: 0.25rem 1.25rem 0 1.25rem;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    // column-gap: 15px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.COLORS.GRAY_3};
      border-radius: 3px;
    }
    .header_item {
      text-align: center;
      border-bottom: 2px solid ${({ theme }) => theme.COLORS.GRAY_3};
      padding: 0.5rem 1rem;
      min-width: 88px;
      flex-shrink: 0;
      white-space: nowrap;
      color: ${({ theme }) => theme.COLORS.GRAY_6};
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
      &.acitve {
        border-bottom: 2px solid ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
  .top_tap_body_layout {
    border-radius: 1rem;
    padding: 1.25rem;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
  }

  .theme_standard {
  }
`;
